// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/ABSListRowsContainer/ABSNews/index.less
// module id = 1093
// module chunks = 42